import {
  beFiltersApiGetCategoryById,
  beFiltersApiGetPagedCategories,
} from 'Api/beFiltersApi';
import { type LabelValuePair } from 'Types/common';

import { MAX_SELECT_ITEMS } from '../../../config/config';

export const fetchCategoriesByName = async (
  name = '',
): Promise<{ items: Array<LabelValuePair<number>>; totalItems: number }> => {
  const categories = await beFiltersApiGetPagedCategories({
    name,
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: MAX_SELECT_ITEMS,
  })

  return {
    items: categories.Items.map((c) => ({
      value: c.Id,
      label: `${c.Id} - ${c.Name}`,
    })),
    totalItems: categories.TotalItems,
  }
}

export const fetchCategoryById = async (
  idCategory: number,
): Promise<LabelValuePair<number>> => {
  const c = await beFiltersApiGetCategoryById(idCategory)

  return {
    value: c.Id,
    label: `${c.Id} - ${c.Name}`,
  }
}
